import Text from 'Pages/Home/Components/Atoms/Text';
import { SidebarMenuContext } from 'Pages/Home/Context/SidebarMenuContext';
import { Row } from 'antd';
import * as React from 'react';
import { useHistory } from 'react-router';
import Styles from './AuthButton.module.scss';
import { TAuthButtonProps } from './definitions';

export default function AuthButton({ type }: TAuthButtonProps) {
  const history = useHistory();
  const { toggleMenuShow } = React.useContext(SidebarMenuContext);

  const onClickLogin = () => {
    history.push('/login');
    toggleMenuShow(false);
  };

  const onClickRegister = () => {
    history.push('/register');
    toggleMenuShow(false);
  };

  if (type === 'login')
    return (
      <Row
        align="middle"
        justify="center"
        className={Styles['auth-login-button']}
        onClick={onClickLogin}
      >
        <Text className={Styles['text']}>Login</Text>
      </Row>
    );
  return (
    <Row
      align="middle"
      justify="center"
      className={Styles['auth-register-button']}
      onClick={onClickRegister}
    >
      <Text className={Styles['text']}>Register</Text>
    </Row>
  );
}
